<template>
  <v-snackbar v-model="isShow" :timeout="snackbar.timeout" location="top" globalTop>
    <template #default>
      <div v-for="(text, index) in snackbar.text.length > 0 ? snackbar.text.split('\n') : [snackbar.text]" :key="index">
        <div v-html="text"></div>
      </div>
    </template>

    <template #actions>
      <v-btn variant="outlined" :color="snackbar.color" @click="handleClose"> Close </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
// import, props, emits, use
const snackbar = useSnackbarStore()

// defineProps({
//   show: {
//     type: Boolean,
//     required: true
//   }
// })

// computed
const isShow = computed({
  get() {
    return snackbar.show
  },
  set(value) {
    if (!value) {
      snackbar.setShow(false)
    }
  }
})

// method
const handleClose = () => {
  snackbar.setShow(false)

  nextTick(() => {
    if (!!snackbar.callback) {
      console.log(`snackbar.callback: ${snackbar.callback}`)
      snackbar.callback()
    }
  })
}
</script>

<style scoped>
pre {
  margin-left: 10px;
}
</style>
